import { platformApiFetch } from '@/services/platformApi/client';
import { debugLogger } from '@/utils/debug';

/**
 * Set user active status
 * @param userId User ID
 * @param isActive Boolean indicating if user should be active
 * @returns Boolean indicating if operation was successful
 */
export async function setUserActiveStatus(userId: string, isActive: boolean): Promise<boolean> {
  try {
    const updatedProfile = await platformApiFetch<{ id: string; is_active: boolean }>(`/v1/admin/users/${userId}/active`, {
      method: 'PUT',
      body: JSON.stringify({ isActive }),
    });

    if (!updatedProfile || updatedProfile.is_active !== isActive) {
      console.error("Failed to update user active status: no matching profile row was updated", {
        userId,
        isActive,
        data: updatedProfile,
      });
      return false;
    }

    return true;
  } catch (error) {
    console.error("Failed to update user active status:", error);
    return false;
  }
}

/**
 * Set user admin status
 * @param userId User ID
 * @param isAdmin Boolean indicating if user should be admin
 * @returns Boolean indicating if operation was successful
 */
export async function setUserAdminStatus(userId: string, isAdmin: boolean): Promise<boolean> {
  try {
    // Log the request for debugging
    debugLogger.log(`Setting admin status for user ${userId} to ${isAdmin}`);

    const updatedUser = await platformApiFetch<{ id: string; is_admin: boolean }>(`/v1/admin/users/${userId}/admin`, {
      method: 'PUT',
      body: JSON.stringify({ isAdmin }),
    });

    if (!updatedUser || updatedUser.is_admin !== isAdmin) {
      console.error("Failed to update user admin status: admin state did not match response", {
        userId,
        isAdmin,
        data: updatedUser,
      });
      return false;
    }
    
    return true;
  } catch (error) {
    console.error("Failed to update user admin status:", error);
    return false;
  }
}
